export enum LearningProgramEnum {
  'tiro' = 1,
  'defensa' = 2,
  'pase' = 3,
  'tactica_individual' = 4,
  'tecnica_individual' = 5,
}
